import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_energy_widget_versions';

const readInitialValue = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
};

/** When true, shows a version label on each energy dashboard widget. */
export const energyWidgetVersionsEnabled = writable<boolean>(readInitialValue());

energyWidgetVersionsEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isEnergyWidgetVersionsEnabled = (): boolean => get(energyWidgetVersionsEnabled);

export const setEnergyWidgetVersionsEnabled = (enabled: boolean) => {
	energyWidgetVersionsEnabled.set(enabled);
};
